module.exports = __webpack_public_path__ + "static/media/temperatura-01.f4714eaf.jpg";